import React from 'react';
import { Badge } from 'antd';
import { SearchOutlined, BellOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import T from './theme';
import i18n from '../../i18n';

function agentLabel(user) {
  if (!user) return i18n.t('messagerie:topbar.agent');
  return `${user.prenoms || user.prenom || ''} ${user.nom || ''}`.trim()
    || user.email || i18n.t('messagerie:topbar.agent');
}

export default function TopBar({ onSearch, unreadCount = 0, user }) {
  const { t } = useTranslation('messagerie');
  const pays = user?.paysLibelle || user?.pays || '';
  const ville = user?.villeLibelle || user?.ville || '';
  const zone = pays ? t('topbar.zone', { lieu: `${pays}${ville ? ` (${ville})` : ''}` }) : '';

  return (
    <header style={{ height: 56, background: T.panel, borderBottom: `1px solid ${T.borderSoft}`,
      display: 'flex', alignItems: 'center', gap: 16, padding: '0 20px', flexShrink: 0 }}>
      <div onClick={onSearch}
        role="button" tabIndex={0}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSearch?.(); } }}
        style={{ flex: 1, maxWidth: 520, position: 'relative', cursor: 'text' }}>
        <SearchOutlined style={{ position: 'absolute', left: 14, top: '50%',
          transform: 'translateY(-50%)', color: T.textMut, fontSize: 13 }} />
        <div style={{ background: '#f1f3f4', borderRadius: T.radius, height: 36,
          display: 'flex', alignItems: 'center', paddingLeft: 38, fontSize: 12.5,
          color: T.textMut }}>
          {t('topbar.rechercher')}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginLeft: 'auto' }}>
        {zone && (
          <span style={{ fontSize: 12, fontWeight: 600, background: T.accentSoft,
            color: '#065f46', padding: '5px 12px', borderRadius: 999 }}>{zone}</span>
        )}
        <Badge dot={unreadCount > 0} color="#f43f5e" offset={[-2, 2]}>
          <BellOutlined style={{ fontSize: 16, color: '#64748b' }} />
        </Badge>
        <div style={{ width: 1, height: 28, background: T.border }} />
        <span style={{ fontSize: 12, fontWeight: 700, color: '#334155' }}>{agentLabel(user)}</span>
      </div>
    </header>
  );
}
